export default "__VITE_ASSET__097396ce__"